import React, { Component } from "react";
import { Grid } from "semantic-ui-react";

import Snjezana from "../img/snjezana.png";
import Kamsiah from "../img/kamsiah.png";
import Massimo from "../img/massimo.png";
import Sergio from "../img/sergio.png";
import Nicole from "../img/nicole.png";
import Delia from "../img/delia.png";

class FeaturedDentists extends Component {
  render() {
    return (
      <Grid className="featured-dentists" centered doubling columns={6}>
        <Grid.Column>
          <a className="-dentist" href="https://www.casemasters.com/user/snjezana-pohl">
            <img className="-img" src={Snjezana} alt="Snjezana Pohl" />
            <p className="-name">Snjezana Pohl</p>
          </a>
        </Grid.Column>
        <Grid.Column>
          <a className="-dentist" href="https://www.casemasters.com/user/massimo-natale">
            <img className="-img" src={Massimo} alt="Massimo Natale" />
            <p className="-name">Massimo Natale</p>
          </a>
        </Grid.Column>
        <Grid.Column>
          <a className="-dentist" href="https://www.casemasters.com/user/delia-tuttle">
            <img className="-img" src={Delia} alt="Delia Tuttle" />
            <p className="-name">Delia Tuttle</p>
          </a>
        </Grid.Column>
        <Grid.Column>
          <a className="-dentist" href="https://www.casemasters.com/user/nicole-fortune">
            <img className="-img" src={Nicole} alt="Nicole Fortune" />
            <p className="-name">Nicole Fortune</p>
          </a>
        </Grid.Column>
        <Grid.Column>
          <a className="-dentist" href="https://www.casemasters.com/user/sergio-castillo">
            <img className="-img" src={Sergio} alt="Sergio Castillo" />
            <p className="-name">Sergio Castillo</p>
          </a>
        </Grid.Column>
        <Grid.Column>
          <a className="-dentist" href="https://www.casemasters.com/user/kamsiah-haider">
            <img className="-img" src={Kamsiah} alt="Kamsiah Haider" />
            <p className="-name">Kamsiah Haider</p>
          </a>
        </Grid.Column>
      </Grid>
    );
  }
}

export default FeaturedDentists;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/FeaturedDentists.js